/**
 * Cross-domain DTO building blocks. Domain-specific DTOs import from here.
 */
import { z } from 'zod';
export const CursorPagination = z.object({
    cursor: z.string().optional(),
    limit: z.number().int().min(1).max(200).default(50),
});
/**
 * Standard response envelope. Every successful REST response is wrapped:
 *   { code: 200, data: <payload>, requestId }
 * Errors flow through HttpExceptionFilter with the same shape:
 *   { code: <http status>, message: <msg>, requestId }
 */
export const ApiResponse = (data) => z.object({
    code: z.number().int(),
    data: data.optional(),
    message: z.string().optional(),
    requestId: z.string(),
});
export const PageResponse = (item) => z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
});
export const UuidParam = z.object({ id: z.string().uuid() });
//# sourceMappingURL=common.js.map